import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useState } from 'react'

import { LogoutController } from '@flowwai-frontend/bps-officer-web/login'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { LogOut1Icon } from '@flowwai-frontend/design-system/icons'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

import * as Styles from './styles'

const UserLogOut = (): React.ReactElement => {
   const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false)

   const { theme } = useAppTheme()
   const themes = theme.iam.userLogOut
   const t = useCustomT('iam:userLogOut')

   const renderLogOutButton = () => (
      <Button
         hierarchy={Hierarchy.Secondary}
         size={'Small'}
         subVariant={SubVariant.DestructiveOutline}
         onClick={() => setIsLogoutModalOpen(true)}
         leftIcon={({ stroke }) => (
            <LogOut1Icon width={16} height={16} fill={stroke} />
         )}
      >
         {t('button')}
      </Button>
   )

   const renderLogoutModal = () => (
      <LogoutController
         isLogoutModalOpen={isLogoutModalOpen}
         setIsLogoutModalOpen={setIsLogoutModalOpen}
      />
   )

   return (
      <React.Fragment>
         <div
            className={cn(
               Styles.containerStyles,
               themes.containerBgColor,
               themes.containerBorderColor
            )}
         >
            <div className={Styles.contentStyles}>
               <div className={cn(Styles.titleStyles, themes.titleColor)}>
                  {t('title')}
               </div>
               <div
                  className={cn(
                     Styles.descriptionStyles,
                     themes.descriptionColor
                  )}
               >
                  {t('description')}
               </div>
            </div>
            {renderLogOutButton()}
         </div>
         {renderLogoutModal()}
      </React.Fragment>
   )
}

export default observer(UserLogOut)
